/**
 * Small formatters shared by the printed breakdown and the export model. Kept
 * apart from both so neither imports the other (the sheet model sits between
 * them).
 */
import dayjs from "dayjs";

export function fmtDate(value) {
  if (value == null || value === "") return null;
  const d = dayjs(typeof value === "string" ? value.split("T")[0] : value);
  return d.isValid() ? d.format("MMM D, YYYY") : null;
}

// The carrier's own eligibility sentence, unless it says nothing the status label
// doesn't already say ("Eligible", "Not eligible today", "Yes"). A real
// explanation — "Not eligible — last done 2026-04-02" — always prints.
const REDUNDANT_VERBATIM = new Set([
  "eligible", "eligible today", "not eligible", "not eligible today", "yes", "no",
]);
export function carrierVerbatim(record) {
  const raw = record && record.eligible_today ? String(record.eligible_today).trim() : "";
  if (!raw) return "";
  const norm = raw.toLowerCase().replace(/[^a-z ]/g, " ").replace(/\s+/g, " ").trim();
  return REDUNDANT_VERBATIM.has(norm) ? "" : raw;
}
